export default __webpack_public_path__ + "static/media/Lisa-Papada.0924f97f.png";